// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__DMG4A","exit":"styles_exit__ouPYy","icon":"styles_icon__arktx"};